// utils/InputService.js

/**
 * This function formats the input value by capitalizing the first letter and 
 * preventing the first space from being entered.
 * 
 * @param {string} value - The current input value
 * @returns {string} - The formatted input value
 */
export const formatInputValue = (value) => {
    // Prevent first space and capitalize the first letter
    if (value.charAt(0) === ' ') {
      return ''; // Return an empty string to prevent first space
    }
  
    // Capitalize the first letter and return the rest as is
    const formattedValue = value.trimStart().charAt(0).toUpperCase() + value.slice(1);
    return formattedValue;
  };